import { stringify as stringifyQs } from "qs";

import {
  ActiveTab,
  BulkAction,
  Dialog,
  Filters,
  Pagination,
  SingleAction,
  TabActionDialog
} from "../../types";

const CustomerActivitySection = "/reports/bi/customer-activities";

export const CustomerActivityListPath = CustomerActivitySection;

export enum CustomerActivityListUrlFiltersEnum {
  joinedFrom = "joinedFrom",
  joinedTo = "joinedTo",
  loginFrom = "loginFrom",
  loginTo = "loginTo",
  lastOrderFrom = "lastOrderFrom",
  lastOrderTo = "lastOrderTo",
  query = "query"
}
export type CustomerActivityListUrlFilters = Filters<
  CustomerActivityListUrlFiltersEnum
>;

export type CustomerActivityListUrlDialog =
  | "remove"
  | "download"
  | TabActionDialog;
export type CustomerActivityUrlQueryParams = ActiveTab &
  CustomerActivityListUrlFilters &
  BulkAction &
  Dialog<CustomerActivityListUrlDialog> &
  Pagination &
  SingleAction;

export const CustomerActivityListUrl = (
  params?: CustomerActivityUrlQueryParams
) => CustomerActivityListPath + "?" + stringifyQs(params);
